import { TableRow } from './input/table-row';
import { ValueCell } from './input/value-cell';

export class ObjToUpdate {
    id: string;
    columnId: string;
    row: TableRow;
    oldValueCell: ValueCell;
    newValue: any;
    type: 'STRING' | 'DATE' | 'NUMBER';
}
